import React, { useState, useEffect } from "react";
import { Box, Typography, Paper, CircularProgress } from "@mui/material";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import GroupsIcon from "@mui/icons-material/Groups";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DiamondIcon from "@mui/icons-material/Diamond";
import StarIcon from "@mui/icons-material/Star";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
export default function Dashboard() {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [stats, setStats] = useState({
        totalProducts: 0,
        totalPlans: 0,
        totalUsers: 0,
        todayIncome: 0,
        thisMonthIncome: 0,
        gold_weight_collected: 0,
        silver_weight_collected: 0,
    });
    useEffect(() => {
        fetchProductData();
    }, []);
    const fetchProductData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "admin/dashboard";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (dataSource) {
            setStats({
                totalProducts: dataSource.total_products || 0,
                totalPlans: dataSource.active_plans || 0,
                totalUsers: dataSource.total_customers || 0,
                todayIncome: dataSource.today_collection || 0,
                thisMonthIncome: dataSource.monthly_collection || 0,
                goldPlanUsers: dataSource.gold_plan_users || 0,
                silverPlanUsers: dataSource.silver_plan_users || 0,
                gold_weight_collected: dataSource.gold_weight_collected || 0,
                silver_weight_collected: dataSource.silver_weight_collected || 0,
            });
        }
    }, [dataSource]);
    const cardData = [
        { title: "Total App Products", value: stats.totalProducts, icon: <Inventory2Icon sx={{ fontSize: 40 }} />, color: "#4caf50" },
        { title: "Total Plans", value: stats.totalPlans, icon: <StarIcon sx={{ fontSize: 40 }} />, color: "#2196f3" },
        { title: "Total Users", value: stats.totalUsers, icon: <GroupsIcon sx={{ fontSize: 40 }} />, color: "#ff9800" },
        { title: "Today's Income", value: `₹${stats.todayIncome?.toLocaleString()}`, icon: <MonetizationOnIcon sx={{ fontSize: 40 }} />, color: "#9c27b0" },
        { title: "This Month Income", value: `₹${stats.thisMonthIncome?.toLocaleString()}`, icon: <CalendarTodayIcon sx={{ fontSize: 40 }} />, color: "#00bcd4" },
        { title: "Gold Plan Users", value: stats.goldPlanUsers, icon: <DiamondIcon sx={{ fontSize: 40 }} />, color: "#ffd700" },
        { title: "Silver Plan Users", value: stats.silverPlanUsers, icon: <DiamondIcon sx={{ fontSize: 40 }} />, color: "#c0c0c0" }
    ];
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>Dashboard</Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
                {cardData.map((card, index) => (
                    <Paper key={index} elevation={1} sx={{ display: "flex", alignItems: "center", p: 3, borderRadius: 3, backgroundColor: card.color, color: "#fff", width: 300, minHeight: 140 }}>
                        <Box sx={{ mr: 3 }}>{card.icon}</Box>
                        <Box>
                            <Typography variant="h6" sx={{ fontWeight: 500 }}>{card.title}</Typography>
                            <Typography variant="h3" sx={{ fontWeight: 700, mt: 0.5 }}>{card.value}</Typography>
                        </Box>
                    </Paper>
                ))}
            </Box>
        </Box>
    );
}